import React, { FC } from "react";
import Heading from "components/Heading/Heading";
import { BlogPost, BlogCategory } from "data/types";
import WidgetTags from "./WidgetTags";
import WidgetPosts from "./WidgetPosts";
import Card3 from "./LatestArticleCard";
import { useNavigate } from 'react-router-dom';

export interface SectionLatestPostsProps {
  className?: string;
  latestPosts: BlogPost[];
  tags: BlogCategory[];
  popular: any[];
  loading: boolean;
}

const SectionLatestPosts: FC<SectionLatestPostsProps> = ({
    className = "",
    latestPosts,
    tags,
    popular,
    loading,
    }) => {
  const navigate = useNavigate();

  return (
      <div className={`nc-SectionLatestPosts relative ${className}`}>
        <div className="flex flex-col lg:flex-row">
          <div className="w-full lg:w-3/5 xl:w-2/3 xl:pr-14">
            <Heading>최신 글</Heading>
            <div className={`grid gap-6 md:gap-8 grid-cols-1`}>
              {loading ? (
                [...Array(3)].map((_, i) => (
                  <div key={i} className="animate-pulse flex flex-col-reverse sm:flex-row sm:items-center gap-4">
                    <div className="flex-1 space-y-3">
                      <div className="flex gap-2">
                        <div className="h-5 w-16 bg-neutral-200 dark:bg-neutral-700 rounded-full" />
                        <div className="h-5 w-16 bg-neutral-200 dark:bg-neutral-700 rounded-full" />
                      </div>
                      <div className="h-6 bg-neutral-200 dark:bg-neutral-700 rounded w-3/4" />
                      <div className="h-4 bg-neutral-200 dark:bg-neutral-700 rounded w-full" />
                      <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-full bg-neutral-200 dark:bg-neutral-700" />
                        <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded w-28" />
                      </div>
                    </div>
                    <div className="sm:w-56 w-full h-36 sm:h-36 rounded-3xl bg-neutral-200 dark:bg-neutral-700 flex-shrink-0" />
                  </div>
                ))
              ) : (
                latestPosts.slice(0, 3).map((item, index) => (
                  <Card3 key={index} post={item} />
                ))
              )}
            </div>
            <div className="flex justify-center mt-10 md:mt-14">
              <button
                onClick={() => navigate('/blog-list')}
                className="px-6 py-2.5 text-sm font-medium border border-neutral-300 dark:border-neutral-700 text-neutral-700 dark:text-neutral-300 rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors"
              >
                더 보기
              </button>
            </div>
          </div>
          <div className="w-full space-y-7 mt-24 lg:mt-0 lg:w-2/5 lg:pl-10 xl:pl-0 xl:w-1/3 ">
            <WidgetTags tags={tags} loading={loading} />
            <WidgetPosts popular={popular} loading={loading} />
          </div>
        </div>
      </div>
  );
};

export default SectionLatestPosts;
